import React, { BaseSyntheticEvent } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { ICriteria, IAction } from '../../ILayoutConfigurationPanel.Interface';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { Utility } from '../../../../../common/utility';

class OnInitSetValuesActionsRulesModalComponent extends React.Component<any, any> {
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private readonly cqUtilityClass: Utility;
    constructor(props: any) {
        super(props);
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
        this.cqUtilityClass = new Utility();
        this.state = {
            setValues: [
                {
                    addedCriterias: [
                        {
                            field: this.props.objectName,
                            operator: '',
                            compareTo: '',
                            isDynamic: false
                        }
                    ],
                    actions: [{
                        field: '',
                        compareTo: '',
                        isDynamic: false,
                        supportedFunctionValue: 0,
                        selectedFieldType: ''
                    }],
                    complexLogicQuery: '',
                }
            ]
        };
    }

    componentDidMount() {

        if (this.props.appliedRule) {
            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objectName: any = this.props.objectName;
            const ruleElement = ruleObject[objectName][this.props.appliedRule];


            if (ruleElement.length !== 0) {
                this.setState({
                    setValues: ruleElement
                }, () => {

                });
            }
        }
    }


    public render() {
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName);
        const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        return (
            <>
                <div className="slds-grid slds-grid_vertical">
                    {
                        this.state.setValues.map((setValueSection: any, setValueSectionIndex: number) => {
                            return (
                                <React.Fragment key={setValueSectionIndex}>
                                    <h3 className="slds-m-bottom_small">Field and Operator</h3>
                                    {
                                        setValueSection.addedCriterias.length > 0 && setValueSection.addedCriterias.map((criteria: ICriteria, criteriaIndex: number) => {
                                            {/* <!-- single row --> */ }
                                            return (
                                                <div key={criteriaIndex} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                                    <div className="slds-col col-sm slds-m-bottom_small">{criteriaIndex + 1}</div>
                                                    <div className="slds-col slds-size_3-of-12">
                                                        <div className="slds-form-element">
                                                            <div className="slds-form-element__control">
                                                                <div className="slds-select_container">
                                                                    <select className="slds-select" id="select-01"
                                                                        disabled={fieldObj.isComponentEventRule ? false : (criteriaIndex === 0)}
                                                                        onChange={e => this.onFieldChanged(e, criteriaIndex, setValueSectionIndex)}
                                                                        value={criteria.field}>
                                                                        <option value="">Select field</option>
                                                                        {
                                                                            layoutFields.map(field => <option key={field.fieldFullName}
                                                                                value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}
                                                                            </option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="slds-col slds-size_2-of-12">
                                                        <div className="slds-form-element">
                                                            <div className="slds-form-element__control">
                                                                <div className="slds-select_container">
                                                                    <select className="slds-select"
                                                                        disabled={(this.props.appliedRule)}
                                                                        value={criteria.operator} onChange={e => this.onOperatorChanged(e, criteriaIndex, setValueSectionIndex)}>
                                                                        <option value="">Please select</option>
                                                                        {
                                                                            CQAppConstant.INPUT_RULE_OPERATORS
                                                                                .map((operator: { label: string, value: string }, index: number) => {
                                                                                    return (<option key={index} value={operator.value}>{operator.label}</option>);
                                                                                })
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="slds-col slds-size_3-of-12">
                                                        {
                                                            !criteria.isDynamic &&
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <input id="" disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'} 
                                                                     value={criteria.compareTo}
                                                                        onChange={e => this.onCompareToTextChanged(e, criteriaIndex, setValueSectionIndex)}
                                                                        placeholder="Placeholder Text" className="slds-input" />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            criteria.isDynamic &&
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <div className="slds-select_container">
                                                                        <select className="slds-select" id="select-01"
                                                                            disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'}
                                                                            value={criteria.compareTo}
                                                                            onChange={e => this.onCompareFieldChanged(e, criteriaIndex, setValueSectionIndex)}>
                                                                            <option value="">Select field</option>
                                                                            {
                                                                                layoutFields.
                                                                                    map(field => <option key={field.fieldFullName}
                                                                                        value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}
                                                                                    </option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                    </div>
                                                    <div className="slds-col slds-size_2-of-12">
                                                        <div className="slds-grid slds-m-bottom_xx-small">
                                                            <label className="slds-checkbox_toggle">
                                                                <input type="checkbox" name="checkbox-toggle-32" value="checkbox-toggle-32"
                                                                    aria-describedby="checkbox-toggle-32"
                                                                    checked={criteria.isDynamic}
                                                                    disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'}
                                                                    onChange={e => this.onDynamicFieldsChanged(e, criteriaIndex, setValueSectionIndex)} />
                                                                <span id="checkbox-toggle-32" className="slds-checkbox_faux_container" aria-live="assertive">
                                                                    <span className="slds-checkbox_faux"></span>
                                                                    <span className="slds-checkbox_on">Dynamic</span>
                                                                    <span className="slds-checkbox_off">Static</span>
                                                                </span>
                                                            </label>

                                                            <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                                this.addCriteria(setValueSectionIndex);
                                                            }}>
                                                                <i className="cq-icon-add"></i>
                                                            </button>
                                                            {criteriaIndex !== 0 &&
                                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                                    this.deleteCriteria(criteriaIndex, setValueSectionIndex);
                                                                }}>
                                                                    <i className="cq-icon-delete"></i>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                            {/* <!-- single row --> */ }
                                        })
                                    }
                                    {
                                        setValueSection.addedCriterias.length > 1 &&
                                        <div className="slds-grid">
                                            <div className="slds-col slds-size_8-of-12">
                                                <div className="slds-form-element slds-form-element_horizontal">
                                                    <label className="slds-form-element__label">Complex Logic</label>
                                                    <div className="slds-form-element__control">
                                                        <input type="text" id="" placeholder="Placeholder Text"
                                                            value={setValueSection.complexLogicQuery} onChange={e => this.onComplexLogicQueryChanged(e, setValueSectionIndex)}
                                                            className="slds-input" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <h3 className="slds-m-bottom_small">Set Action</h3>
                                    {
                                        setValueSection.actions.length > 0 && setValueSection.actions.map((action: IAction, actionIndex: number) => {
                                            {/* <!-- single row --> */ }
                                            return (
                                                <div key={actionIndex} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                                    <div className="slds-col col-sm slds-m-bottom_small">{actionIndex + 1}</div>
                                                    <div className="slds-col slds-size_4-of-12">
                                                        <div className="slds-form-element">
                                                            <div className="slds-form-element__control">
                                                                <div className="slds-select_container">
                                                                    <select className="slds-select" id="select-01"
                                                                        onChange={e => this.onActionFieldChanged(e, actionIndex, setValueSectionIndex, layoutFields)}
                                                                        value={action.field}>
                                                                        <option value="">Select action field</option>
                                                                        {
                                                                            layoutFields.
                                                                                map(field => <option key={field.fieldFullName}
                                                                                    value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}
                                                                                </option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="slds-col slds-size_4-of-12">
                                                        {
                                                            !action.isDynamic && action.selectedFieldType !== 'Checkbox' &&
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <input id="" value={action.compareTo}
                                                                        type={this.getTextInputTypeBasedOnFieldType(action.selectedFieldType)}
                                                                        onChange={e => this.onActionValueChanged(e, actionIndex, setValueSectionIndex, false)}
                                                                        placeholder="Enter action value" className="slds-input" />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            !action.isDynamic && action.selectedFieldType === 'Checkbox' &&
                                                            <label className="slds-checkbox_toggle">
                                                                <input type="checkbox" name="checkbox-toggle-32" value="checkbox-toggle-32"
                                                                    aria-describedby="checkbox-toggle-32"
                                                                    onChange={e => this.onActionValueChanged(e, actionIndex, setValueSectionIndex, true)} />
                                                                <span id="checkbox-toggle-32" className="slds-checkbox_faux_container" aria-live="assertive">
                                                                    <span className="slds-checkbox_faux"></span>
                                                                    <span className="slds-checkbox_on">True</span>
                                                                    <span className="slds-checkbox_off">False</span>
                                                                </span>
                                                            </label>
                                                        }
                                                        {
                                                            action.isDynamic && action.compareTo === 'AddDays()' &&
                                                            <div className="slds-form-element ">
                                                                <div className="slds-form-element__control">
                                                                    <input id="" value={action.supportedFunctionValue}
                                                                        type="number"
                                                                        onChange={e => this.onActionSupportedFuncValueChanged(e, actionIndex, setValueSectionIndex)}
                                                                        placeholder="Enter value of AddDays() function" className="slds-input" />
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            action.isDynamic &&
                                                            <div className="slds-form-element">
                                                                <div className="slds-form-element__control">
                                                                    <div className="slds-select_container">
                                                                        <select className="slds-select" id="select-01"
                                                                            value={action.compareTo}
                                                                            onChange={e => this.onActionValueChanged(e, actionIndex, setValueSectionIndex, false)}>
                                                                            <option value="">Select dynamic Value</option>
                                                                            {
                                                                                CQAppConstant.SETVALUE_RULE_DYNAMIC_SOURCE_VALUES.
                                                                                    map(field => <option key={field.label}
                                                                                        value={field.label}>{`${field.label}`}
                                                                                    </option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }

                                                    </div>
                                                    <div className="slds-col slds-size_2-of-12">
                                                        <div className="slds-grid slds-m-bottom_xx-small">
                                                            <label className="slds-checkbox_toggle">
                                                                <input type="checkbox" name="checkbox-toggle-32" value="checkbox-toggle-32"
                                                                    aria-describedby="checkbox-toggle-32"
                                                                    checked={action.isDynamic}
                                                                    onChange={e => this.onDynamicActionChanged(e, actionIndex, setValueSectionIndex)} />
                                                                <span id="checkbox-toggle-32" className="slds-checkbox_faux_container" aria-live="assertive">
                                                                    <span className="slds-checkbox_faux"></span>
                                                                    <span className="slds-checkbox_on">Dynamic</span>
                                                                    <span className="slds-checkbox_off">Static</span>
                                                                </span>
                                                            </label>

                                                            <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                                this.addAction(setValueSectionIndex);
                                                            }}>
                                                                <i className="cq-icon-add"></i>
                                                            </button>
                                                            {actionIndex !== 0 &&
                                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                                    this.deleteAction(actionIndex, setValueSectionIndex);
                                                                }}>
                                                                    <i className="cq-icon-delete"></i>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                            {/* <!-- single row --> */ }
                                        })
                                    }

                                </React.Fragment>
                            );
                        })
                    }
                    <div className="slds-grid_absolute-center">
                        <button className="slds-button slds-button_neutral slds-m-top_x-small"
                            onClick={this.addSetValueSection}
                        >Add Condition</button>
                    </div>
                </div>
            </>
        );
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onFieldChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].field = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onActionFieldChanged = (e: BaseSyntheticEvent, actionIndex: number, setValueSectionIndex: number, layoutFields: any[]) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].actions[actionIndex].field = e.target.value;
        const filteredField = layoutFields.filter((field: any) => field.fieldFullName === setValues[setValueSectionIndex].actions[actionIndex].field);
        setValues[setValueSectionIndex].actions[actionIndex].selectedFieldType = filteredField[0].fieldType;
        this.setState({ setValues }, () => {

            this.updateRuleObject(CQAppConstant.SET_VALUES, setValues);
        }
        );
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onActionValueChanged = (e: BaseSyntheticEvent, actionIndex: number, setValueSectionIndex: number, isToggleValue: boolean) => {
        const setValues = this.state.setValues;
        !isToggleValue ?
            setValues[setValueSectionIndex].actions[actionIndex].compareTo = e.target.value :
            setValues[setValueSectionIndex].actions[actionIndex].compareTo = e.target.checked;
        this.setState({ setValues }, () => {

            this.updateRuleObject(CQAppConstant.SET_VALUES, setValues);
        });
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onActionSupportedFuncValueChanged = (e: BaseSyntheticEvent, actionIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].actions[actionIndex].supportedFunctionValue = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onCompareFieldChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }


    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onOperatorChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator = e.target.value;
        
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = (setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator === 'Exists'
        || setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator === 'IsEmpty')
        ? '' : setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo;

        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onCompareToTextChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));

    }


    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onComplexLogicQueryChanged = (e: BaseSyntheticEvent, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].complexLogicQuery = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onDynamicFieldsChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].isDynamic = e.target.checked;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));

    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private onDynamicActionChanged = (e: BaseSyntheticEvent, actionIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].actions[actionIndex].isDynamic = e.target.checked;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof ToggleActionsRulesModalComponent
     */
    private addCriteria = (setValueSectionIndex: number) => {
        const critetia = {
            field: '',
            operator: '',
            compareTo: '',
            isDynamic: false
        };
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias.push(critetia);
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, this.state));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private addAction = (setValueSectionIndex: number) => {
        const action = {
            field: '',
            fieldType: '',
            compareTo: '',
            isDynamic: false
        };
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].actions.push(action);
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private deleteCriteria = (criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let addedCriterias = setValues[setValueSectionIndex].addedCriterias;
        addedCriterias = addedCriterias.filter((criteria: any, index: number) => index !== criteriaIndex);
        setValues[setValueSectionIndex].addedCriterias = addedCriterias;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private deleteAction = (actionIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let actions = setValues[setValueSectionIndex].actions;
        actions = actions.filter((action: any, index: number) => index !== actionIndex);
        setValues[setValueSectionIndex].actions = actions;
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, setValues));
    }

    /**
    * @private
    * @memberof ToggleActionsRulesModalComponent
    */
    private readonly addSetValueSection = () => {
        const setValueSection = {
            addedCriterias: [
                {
                    field: this.props.objectName,
                    operator: '',
                    compareTo: '',
                    isDynamic: false
                }
            ],
            actions: [{
                field: '',
                compareTo: '',
                isDynamic: false,
                supportedFunctionValue: undefined,
                selectedFieldType: ''
            }],
            complexLogicQuery: '',
        };
        const setValues = this.state.setValues;
        setValues.push(setValueSection);
        this.setState({ setValues }, () => this.updateRuleObject(CQAppConstant.SET_VALUES, this.state));
    }

    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        this.props.setRuleObject(ruleObjectValue);
        this.props.checkValidation(this.validateAddRuleForm());
    }


    /**
     * @private
     * @memberof OnLoadSetValuesRulesModalComponent
     */
    private readonly validateAddRuleForm = () => {
        let isComplexLogicValid = false;
        let isActionsValid = false;
        let isCriteriaValid = false;
        this.state.setValues.forEach((setValueSection: any) => {
            isCriteriaValid = setValueSection.addedCriterias.every((criteria: ICriteria) => (
                criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))));
            isActionsValid = setValueSection.actions.every((action: any) => (
                action.field !== ''
                && action.compareTo !== ''));
            if (setValueSection.addedCriterias.length === 1 && setValueSection.complexLogicQuery === '') {
                isComplexLogicValid = true;
            } else if (setValueSection.addedCriterias.length > 1 && setValueSection.complexLogicQuery === '') {
                isComplexLogicValid = false;
            } else if (setValueSection.addedCriterias.length > 1 && setValueSection.complexLogicQuery !== '') {
                isComplexLogicValid = true;
            }
        });
        if (!isCriteriaValid || !isActionsValid || !isComplexLogicValid) {
            return true;
        }
        return false;
    }

    private readonly getTextInputTypeBasedOnFieldType = (fieldType: string) => {
        switch (fieldType) {
            case 'Number': return 'number';
                break;
            case 'Date': return 'date';
                break;
            case 'Text': return 'text';
                break;
            default: return 'text';
        }
    }

}
export const OnInitSetValuesActionsRulesModal = observer(OnInitSetValuesActionsRulesModalComponent);
